<template>
  <dashboard-widget title="HINT" no-zoom @delete="$emit('delete','DashboardHint')" :width="width" :enableDelete="enableDelete">
    <v-btn v-if="!enableDelete" icon small @click="refresh()" style="position:absolute;right:10px;top:10px"><v-icon>mdi-refresh</v-icon></v-btn>
    <div class="text-body-2 mt-4">
      <div class="text-center mb-4"><v-icon large color="green">mdi-lightbulb-on</v-icon></div>
        <div v-html="hint"/>
    </div>
  </dashboard-widget>
</template>

<script>

export default {
  name: 'DashboardHint',
  props: {
    width: {type:Number, required:false, default:290},
    enableDelete: {type: Boolean, required:false, default:false}
  },
  data() {
    return {
      hint: ''
    }
  },
  created() {
    this.refresh();
  },
  methods: {
    async refresh() {
      const results = await this.$apiCall(`query DashboardHint {
                                             hint
                                           }`, {});
      if (!results.error)
        this.hint = results.data.hint;
    }
  }
}
</script>